import type { SVGProps } from "react";
export interface FortIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FortIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FortIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.36 7.884a1.126 1.126 0 0 1 1.236.863l.02.114 1.378 11.014H22l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-7A1.125 1.125 0 0 1 13.877 21v-4a1.876 1.876 0 0 0-3.75 0v4c0 .621-.504 1.125-1.126 1.125H2a1.125 1.125 0 0 1 0-2.25h.007L3.384 8.861a1.125 1.125 0 1 1 2.233.278L4.275 19.875h3.6V17a4.125 4.125 0 0 1 8.25 0v2.875h3.601L18.384 9.139l-.009-.114a1.125 1.125 0 0 1 .985-1.141"
      />
      <path
        fill={color}
        d="M12.875 3.5a.375.375 0 0 0-.375-.375h-1a.375.375 0 0 0-.376.375A2.625 2.625 0 0 1 8.5 6.125h-1A2.625 2.625 0 0 1 4.875 3.5a.375.375 0 0 0-.375-.375h-1a.375.375 0 0 0-.375.375V6c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.874-.84 1.875-1.875V3.5a.375.375 0 0 0-.375-.375h-1a.375.375 0 0 0-.375.375A2.625 2.625 0 0 1 16.5 6.125h-1A2.625 2.625 0 0 1 12.875 3.5M23.125 6A4.125 4.125 0 0 1 19 10.126H5A4.125 4.125 0 0 1 .875 6V3.5A2.625 2.625 0 0 1 3.5.875h1A2.625 2.625 0 0 1 7.125 3.5c0 .207.168.375.375.375h1a.375.375 0 0 0 .375-.375A2.625 2.625 0 0 1 11.499.875H12.5A2.625 2.625 0 0 1 15.125 3.5c0 .207.168.375.375.375h1a.375.375 0 0 0 .375-.375A2.625 2.625 0 0 1 19.5.875h1A2.625 2.625 0 0 1 23.125 3.5z"
      />
    </svg>
  );
}
